export const parseUsersFilteredByAdmin = data => {
  return (
    data
      ?.filter(user => user?.isAdministrator)
      .map(user => ({ value: user?.profileRef, label: `${user?.firstName} ${user?.lastName}` })) || []
  );
};
